<template>
<b-modal id="play-modal" size="lg" title="Play Game">
    <div class="modal-body text-center"> 
        <h2 class="mb-4">
            {{ item.category }}
            <span v-if="item.isComplete">
                 - {{ item.answer }}
            </span>
        </h2>
        <div class="word-display">
            <div v-for="(word, index) in item.wordCount" :key="index" class="row no-gutters justify-content-center">
                <div v-for="(letter, index) in item.lettersPerWord[index]" :key="index" class="col-1">
                    <div class="letter">
                        <span v-if="letter">
                            {{ letter }}
                        </span>
                        <span v-else>
                            -
                        </span>
                    </div> 
                </div>
            </div> 
        </div>
        <div v-if="item.isComplete">
            <div v-if="item.winner">
                <h5>
                    We have a winner:
                </h5>
                <h5>
                    {{ item.winner }} 
                </h5>
            </div>
            <div v-else>
                <h4>
                    This Game is over, with no Winner!
                </h4>         
            </div>
        </div>
        <div class="mt-4">
            {{ item.guesses.join(', ') }}
        </div>
        <div class="mt-1">
            <sub>{{ item.guesses.length }} of {{ item.maxGuesses }} Guesses Remaining</sub>
        </div>

        <div class="letter-selection">
            <div class="row no-gutters justify-content-center mb-3">
                <div  class="col-9">
                    <input type="text" class="form-control" v-model="guessword" placeholder="Take a guess?" />         
                </div>
            </div> 
            <div class="row no-gutters justify-content-center">
                <div v-for="(letter, index) in letterGroupOne" :key="index" class="col-1">
                    <div @click="selectLetter(letter)" :class="{ selected: selectedLetters[0] == letter ||  selectedLetters[1] == letter }" class="letter">
                        {{ letter }}
                    </div>           
                </div>
            </div>  
            <div class="row no-gutters justify-content-center">
                <div v-for="(letter, index) in letterGroupTwo" :key="index" class="col-1">
                    <div @click="selectLetter(letter)" :class="{ selected: selectedLetters[0] == letter ||  selectedLetters[1] == letter }" class="letter">
                        {{ letter }}
                    </div>           
                </div>
            </div>  
            <div class="row no-gutters justify-content-center">
                <div v-for="(letter, index) in letterGroupThree" :key="index" class="col-1">
                    <div @click="selectLetter(letter)" :class="{ selected: selectedLetters[0] == letter ||  selectedLetters[1] == letter }" class="letter">
                        {{ letter }}
                    </div>           
                </div>
            </div> 
            <div class="mt-3">
                <sub>2 Guesses Allowed Per Transaction</sub>
            </div>
        </div>         
    </div>
    <div slot="modal-footer" class="modal-footer-inner">
        <button type="button" class="btn btn-secondary" @click="hideModal">
            Close
        </button>
        <button v-if="!item.isComplete && !pendingTransaction" type="button" class="btn btn-primary" @click="submitTransaction">
            Submit
        </button>
        <button v-if="!item.isComplete && pendingTransaction" class="btn btn-secondary">
            Please wait ...
        </button>   
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";


export default {
    name: "modal-play",
    data () {
        return {
            letterGroupOne: [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I' ],
            letterGroupTwo: [ 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R' ],
            letterGroupThree: [ 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ],
            selectedLetters: [],
            guessword: null
        }
    },
    computed: {
        ...mapGetters({
            item: 'getItem',
            pendingTransaction: 'getPendingTransaction'
        })  
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','play-modal');
        },

        selectLetter (letter) {
            if (this.selectedLetters.length == 2) {
                this.selectedLetters.splice(0, 1);
            }
            this.selectedLetters.push(letter);
        },

        submitTransaction () {
            const id = this.item.id;

            if (this.selectedLetters.length < 2) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Make 2 guesses please!'
                });

                return;
            }

            this.$store.commit('updatePendingTransaction', { status: true });

            const letterOne = this.selectedLetters[0];
            const letterTwo = this.selectedLetters[1];
            const guessword = this.guessword;

            const args = "[\"" + id + "\",\"" +  letterOne + "\",\"" + letterTwo + "\",\"" + guessword + "\"]";
            this.$store.dispatch('playGame', { args }).then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'Please see results below!'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error! Please try again.'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });

            });

        }
    }
};
</script>

<style scoped lang="less">
.form-control {
    border-radius: 0;
    margin: 5px;
}

.word-display {
    .letter {
        margin: 5px;
        padding: 20px 10px;
        border: 1px solid #ccc;
    }
}

.letter-selection {
    border-top: 1px solid #efefef;
    padding-top: 30px;
    margin-top: 30px;

    .letter {
        cursor: pointer;
        padding: 20px 10px;
        border: 1px solid #ccc;
        margin: 5px;
        &:hover {
            background: #efefef;
        }

        &.selected {
            background: #ccc;
            color: #fff;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/ModalPlay.vue